import i18n from '@/i18n';
import { taskAPI } from '@/utils/api';
import { IMG2IMG_OUTPUT_PER_SOURCE } from '@/pages/ipe/workbench/constants/img2imgStudioConfig';
import { buildRetryTaskApiPatch } from './ipeTaskActions';

function readRetryContext(task) {
  const r = task?.result && typeof task.result === 'object' ? task.result : {};
  const prompt = String(r.prompt || '').trim();
  const urls = Array.isArray(r.referenceUrls) ? r.referenceUrls.filter(Boolean) : [];
  const previews = Array.isArray(r.referencePreviews) ? r.referencePreviews.filter(Boolean) : [];
  return { prompt, urls, previews };
}

/** 万能改图历史重试：重新入队服务端 Worker（RabbitMQ / job_task） */
export async function retryImg2imgTask(task) {
  const taskId = String(task?.id || '').trim();
  if (!taskId) throw new Error(i18n.t('workbench:ipeUtilError.taskInvalid'));

  const { prompt, urls, previews } = readRetryContext(task);
  if (!prompt && urls.length === 0 && previews.length === 0) {
    throw new Error(i18n.t('workbench:ipeUtilError.taskMissingPromptOrRef'));
  }

  // 一图一生：忽略历史任务里可能残留的 generateCount>1
  const refCount = urls.length > 0 ? urls.length : (previews.length > 0 ? previews.length : 0);
  const estimatedTotal = refCount > 0
    ? refCount * IMG2IMG_OUTPUT_PER_SOURCE
    : IMG2IMG_OUTPUT_PER_SOURCE;
  const apiPatch = buildRetryTaskApiPatch({
    total: estimatedTotal,
    successCount: 0,
    failedCount: 0,
  });
  const prevResult = task?.result && typeof task.result === 'object' ? task.result : {};
  await taskAPI.update(taskId, {
    ...apiPatch,
    result: {
      ...prevResult,
      generateCount: IMG2IMG_OUTPUT_PER_SOURCE,
      serverWorker: true,
      batchMode: Array.isArray(prevResult.referenceUrls) && prevResult.referenceUrls.length > 1,
      batchPhase: 'queued',
      outputs: [],
      urls: [],
    },
  });
  await taskAPI.submit(taskId, { force: true });
}
